import parent from '@/store/interfaces/historicalGeneric'
const mystore = parent({ tipoEvento: 'distribuidor', namespaced: true })

export default mystore
